
import React, { PureComponent } from 'react'
import { Button, Modal, Col, Table } from 'react-bootstrap'
import { reduxForm, Field } from 'redux-form'
import InputText from '../../commons/form/InputText'
import SimpleTablePage from '../../../containers/commons/general/SimpleTablePage'
import InputCheckbox from '../../commons/form/InputCheckBox'
import { handleKeyDown } from '../../../util/utils'

class FinancingTypeProductModal extends PureComponent {
  constructor () {
    super()
    this.state = { reactivatable: false, repurchaseAgreement: false }
  }

  submitFinancingTypeProduct (values) {
    const financingTypeProductLanguage = []
    Object.keys(values).map(item => {
      if (typeof values[item] === 'boolean') {

      }
      if (item.includes('lang')) {
        financingTypeProductLanguage.push(values[item])
      }
    })

    var typeProduct = {}
    typeProduct.financingTypeProductId = this.props.financingTypeProductId
    typeProduct.name = values.financingTypeProduct.name
    typeProduct.reactivatable = values.reactivatable
    typeProduct.repurchaseAgreement = values.repurchaseAgreement
    typeProduct.financingTypeProductLanguage = financingTypeProductLanguage
    typeProduct.Fields = []
    this.props.fields.map(field => {
      var tempField = {}
      tempField.fieldId = field.fieldId
      tempField.financingFieldsProductId = field.financingFieldsProductId
      tempField.mandatory = values.field[field.fieldId]
      typeProduct.Fields.push(tempField)
    })

    this.props.actions.saveFinancingTypeProductModal(typeProduct)
  }

  UNSAFE_componentWillReceiveProps (nextProps) {
    if (this.props.financingTypeProductLanguage !== nextProps.financingTypeProductLanguage && nextProps.financingTypeProductId !== this.props.financingTypeProductId || this.props.showModal !== nextProps.showModal) {
      nextProps.languageList.map((language) => {
        this.props.change(`lang${language.languageId}.languageId`, language.languageId)
        const source = nextProps.financingTypeProductLanguage ? nextProps.financingTypeProductLanguage.find((sourceChannel) => sourceChannel.languageId === language.languageId) : null
        this.props.change(`lang${language.languageId}.description`, source ? source.description : '')
      })
      this.props.change('reactivatable', nextProps.financingTypeProduct ? nextProps.financingTypeProduct.reactivatable ? nextProps.financingTypeProduct.reactivatable : false : false)
      this.props.change('repurchaseAgreement', nextProps.financingTypeProduct ? nextProps.financingTypeProduct.repurchaseAgreement ? nextProps.financingTypeProduct.repurchaseAgreement : false : false)
      this.props.change('financingTypeProduct.name', nextProps.financingTypeProduct ? nextProps.financingTypeProduct.name ? nextProps.financingTypeProduct.name : '' : '')
    }

    if (this.props.fields && nextProps.financingTypeProductId !== this.props.financingTypeProductId || this.props.showModal !== nextProps.showModal) {
      this.props.fields.map((f) => {
        this.props.change(`field.${f.fieldId}`, nextProps.financingTypeProduct ? nextProps.financingTypeProduct.fields.find(x => x.financingFieldsProductId === f.financingFieldsProductId) ? nextProps.financingTypeProduct.fields.find(x => x.financingFieldsProductId === f.financingFieldsProductId).mandatory : false : false)
      })
    }

    if (this.props.financingTypeProductId !== nextProps.financingTypeProductId || nextProps.financingTypeProductId == null || nextProps.reactivatable === undefined) {
      this.setState({ reactivatable: undefined })
      this.setState({ repurchaseAgreement: undefined })
    }

    if (this.props.reactivatable !== nextProps.reactivatable) {
      if (nextProps.reactivatable === null || nextProps.reactivatable === undefined) {
        this.setState({ reactivatable: false })
      } else {
        this.setState({ reactivatable: nextProps.reactivatable })
      }
    }

    if (this.props.financingTypeProductId !== nextProps.financingTypeProductId || nextProps.financingTypeProductId == null || nextProps.repurchaseAgreement === undefined) {
      this.setState({ repurchaseAgreement: undefined })
    }
    if (this.props.repurchaseAgreement !== nextProps.repurchaseAgreement) {
      if (nextProps.repurchaseAgreement === null || nextProps.repurchaseAgreement === undefined) {
        this.setState({ repurchaseAgreement: false })
      } else {
        this.setState({ repurchaseAgreement: nextProps.repurchaseAgreement })
      }
    }
  }

  checkReactivatable (val) {
    this.setState({ reactivatable: val })
  }

  checkRepurchaseAgreement (val) {
    this.setState({ repurchaseAgreement: val })
  }

  render () {
    const { t, showModal, handleSubmit, languageList = [], fields } = this.props
    const tKey = 'MASTERS.FINANCING_TYPE_PRODUCT.'
    return (
      <Modal id="financingTypeProductModal" show={showModal} onHide={this.props.actions.closeEditFinancingTypeModalProduct} className="_nf">
        <Modal.Header closeButton>
          <Modal.Title>{t(`${tKey}FINANCING_TYPE_PRODUCT`)}</Modal.Title>
        </Modal.Header>
        <form autoComplete="off" onSubmit={handleSubmit(this.submitFinancingTypeProduct.bind(this))} onKeyDown={(e) => handleKeyDown(e)}>
          <Modal.Body>
            <div className="search-form">
              <Field
                component={InputText}
                colWidth={100} // 25, 33, 50, 75, 100 default=25
                name={'financingTypeProduct.name'}S
                controlLabel={t(`${tKey}FINANCING_TYPE_PRODUCT`)}
                placeholder={t('MASTERS.NAME')}
                className={'finance-type-button'}
              />
            </div>
            <SimpleTablePage
              // customClass={'langTable'}
              columns={[
                <th className='colWidth-15 alignC' key={2}>
                  {t('MASTERS.LANGUAGE')}
                </th>,
                <th className='colWidth-55' key={1}>
                  {t('MASTERS.DESCRIPTION')}
                </th>
              ]}
              rows={languageList && languageList.map((val, idx) => (
                <tr key={idx}>
                  <td className='alignC'>
                    <p><span>{`${val.description}`}</span></p>
                    <p>{`(${val.name})`}</p>
                  </td>
                  <td>
                    <Field
                      component={InputText}
                      colWidth={100} // 25, 33, 50, 75, 100 default=25
                      name={`lang${val.languageId}.description`}
                      placeholder={t('MASTERS.DESCRIPTION')}
                      maxLength={100}
                    />
                  </td>
                </tr>
              ))}
            />
            <h5>{t('MASTERS.FINANCING_TYPE.OTHERS')}</h5>
            <div className="search-form">
              <Field
                component={InputCheckbox}
                colWidth={50} // 25, 33, 50, 75, 100 default=25
                name={'reactivatable'}
                id={'reactivatable'}
                placeholder ={t('MASTERS.FINANCING_TYPE.REACTIVATABLE_INSTORED')}
                checked = {this.state.reactivatable}
                onChange = {(value) => this.checkReactivatable(value) }
              />
              <Field
                component={InputCheckbox}
                colWidth={50} // 25, 33, 50, 75, 100 default=25
                name={'repurchaseAgreement'}
                id={'repurchaseAgreement'}
                placeholder ={t(`${tKey}REPURCHASE`)}
                checked = {this.state.repurchaseAgreement}
                onChange = {(value) => this.checkRepurchaseAgreement(value) }
              />
            </div>
            <h5> {t(`${tKey}CONFIGURATION_FIELDS`)}:</h5>
            <div className="search-form tableContainer">
              <Table className="editable-table" hover responsive>
                <thead>
                  <tr>
                    <th>
                      {t(`${tKey}FIELD`)}
                    </th>
                    <th className='actions'>
                      {t(`${tKey}MANDATORY`)}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {fields && fields.map((financingField, idx) => (
                    <tr key={'tdfielTr_' + idx}>
                      <td key={'tdfieldName_' + idx}>
                        {('0' + (idx + 1)).slice(-2) + '.' + financingField.name}
                      </td>
                      <td className='actions' key={'tdfieldCheck_' + idx}>
                        <div>
                          {
                            <Field
                              component={InputCheckbox}
                              name={'field.' + financingField.fieldId}
                            />
                          }
                        </div>

                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Col sm={12} className="flexInLine al-R">
              <Button type="submit" className="_Btn new">
                {t('MASTERS.SAVE')}
              </Button>
            </Col>
          </Modal.Footer>
        </form>
      </Modal>
    )
  }
}
const validate = (values, props) => {
  const errors = { financingTypeProduct: {} }
  props.languageList.map(language => {
    errors[`lang${language.languageId}`] = {}
    if (values[`lang${language.languageId}`]) {
      if (!(values[`lang${language.languageId}`].description)) {
        errors[`lang${language.languageId}`].description = props.t('MASTERS.VALIDATION.DESCRIPTION_REQUIRED')
      }
    } else {
      errors[`lang${language.languageId}`].description = props.t('MASTERS.VALIDATION.DESCRIPTION_REQUIRED')
    }
  })
  if (values) {
    if (!values.financingTypeProduct) {
      errors.financingTypeProduct.name = props.t('MASTERS.VALIDATION.PRODUCT_TYPE_REQUIRED')
    }
  }
  return errors
}

export default reduxForm({
  form: 'financingTypeProductModal',
  validate
})(FinancingTypeProductModal)
